module.exports = __webpack_public_path__ + "img/katom_no.64a39803.png";